import ServicoAPI from "../../../servicos/ServicoAPI.js"

export const GV_HUB_ABA_PERTO = "perto"
export const GV_HUB_ABA_MINHAS = "minhas"
export const GV_HUB_ABA_FILA = "fila"

export function resolverEntradaHub(location, propEntrada) {
	if (propEntrada === "fab" || propEntrada === "menu") return propEntrada
	const qs = new URLSearchParams(location?.search || "")
	const fromQs = qs.get("entrada")
	if (fromQs === "fab" || fromQs === "menu") return fromQs
	const fromState = location?.state?.entrada
	if (fromState === "fab" || fromState === "menu") return fromState
	return "menu"
}

export function normalizarVagaFilaCard(item) {
	if (!item || typeof item !== "object") return null
	const fila = item.fila && typeof item.fila === "object" ? item.fila : {}
	return {
		...fila,
		...item,
		id: Number(item.id ?? fila.id ?? 0),
	}
}

/**
 * Carrega hub unificado; em falha usa rotas legadas (listar + prioridade + fila).
 */
/**
 * Exibe modal de vaga urgente hoje? (espelha regra do hub PHP).
 * Não exibir se já é titular com jornada hoje em alguma vaga (ir para fila).
 */
export function resolverExibirModalPrioridadeIngresso(filaVagasBrutas, prioridadeHoje) {
	if (prioridadeHoje?.exibirModal === false) return false
	if (prioridadeHoje?.exibirModal === true) return true
	if (!prioridadeHoje?.principal?.id) return false

	const filas = Array.isArray(filaVagasBrutas) ? filaVagasBrutas : []
	for (const item of filas) {
		const f = item?.fila && typeof item.fila === "object" ? item.fila : item
		if (f?.jornadaHoje) return false
	}
	return true
}

export async function carregarGestaoVagaHub(dados, geo, { entrada = "menu" } = {}) {
	try {
		const r = await ServicoAPI.gestaoVagasHubApp(dados, geo, {
			entrada,
			incluirPrioridade: true,
		})
		if (r?.resultado === true && r?.dados?.abas) {
			return { ok: true, fonte: "hub", dados: r.dados }
		}
	} catch {
		// fallback
	}

	return carregarGestaoVagaHubFallback(dados, geo, { entrada })
}

async function carregarGestaoVagaHubFallback(dados, geo, { entrada }) {
	const listagem = { quantidade: 0, vagas: [], vagaUnica: null, erro: "" }
	let prioridadeHoje = null
	let filaEstado = { vagas: [], diagnostico: null, erro: "" }

	const rList = await ServicoAPI.gestaoVagasListarApp(dados, geo)
	if (rList?.resultado === true) {
		const info = rList.dados ?? {}
		listagem.quantidade = Number(info.quantidade) || 0
		listagem.vagas = Array.isArray(info.vagas) ? info.vagas : []
		listagem.vagaUnica = info.vagaUnica ?? null
		listagem.erro = info.erro ? String(info.erro) : ""
	} else {
		listagem.erro = rList?.mensagem || "Não foi possível carregar as vagas."
	}

	try {
		const rp = await ServicoAPI.gestaoVagasPrioridadeIngressoHoje(dados, geo)
		if (rp?.resultado === true) {
			prioridadeHoje = rp.dados ?? null
		}
	} catch {
		prioridadeHoje = null
	}

	const rFila = await ServicoAPI.gestaoVagasFilaApp(dados, geo)
	if (rFila?.resultado === true) {
		const info = rFila.dados ?? {}
		filaEstado.vagas = Array.isArray(info.vagas) ? info.vagas : []
		filaEstado.diagnostico = info.diagnostico ?? null
		filaEstado.erro = info.erro ? String(info.erro) : ""
	}

	const perto = []
	const minhas = []
	for (const v of listagem.vagas) {
		if (v?.ingresso?.jaTitular) minhas.push(v)
		else perto.push(v)
	}

	const filaHoje = filaEstado.vagas.map((linha) => {
		const base = minhas.find((m) => Number(m.id) === Number(linha.id))
		return normalizarVagaFilaCard(
			base ? { ...base, fila: linha } : { ...linha, fila: linha }
		)
	})

	const abaInicial =
		entrada === "fab" ? GV_HUB_ABA_FILA : GV_HUB_ABA_PERTO

	if (prioridadeHoje) {
		prioridadeHoje.exibirModal = resolverExibirModalPrioridadeIngresso(
			filaEstado.vagas,
			prioridadeHoje
		)
	}

	return {
		ok: listagem.erro === "" || filaHoje.length > 0,
		fonte: "fallback",
		dados: {
			entrada,
			abaInicial,
			textosUx: {},
			abas: {
				perto: { quantidade: perto.length, vagas: perto },
				minhas: { quantidade: minhas.length, vagas: minhas },
				filaHoje: { quantidade: filaHoje.length, vagas: filaHoje },
			},
			listagem,
			fila: filaEstado,
			prioridadeHoje,
		},
	}
}

export function aplicarPrioridadeLista(vagas, prioridadeHoje, filaVagasBrutas = []) {
	const principalApi = prioridadeHoje?.principal
	const prioridades = Array.isArray(prioridadeHoje?.prioridades)
		? prioridadeHoje.prioridades
		: []
	const idsPri = new Set(
		prioridades.map((p) => Number(p?.id)).filter((id) => id > 0)
	)
	const principal =
		principalApi?.id != null
			? {
					...vagas.find((v) => Number(v?.id) === Number(principalApi.id)),
					...principalApi,
				}
			: null
	let lista = [...vagas]
	if (idsPri.size > 0) {
		const urgentes = lista.filter((v) => idsPri.has(Number(v?.id)))
		const demais = lista.filter((v) => !idsPri.has(Number(v?.id)))
		lista = [...urgentes, ...demais]
	}
	const exibirModal = resolverExibirModalPrioridadeIngresso(filaVagasBrutas, prioridadeHoje)

	return {
		vagas: lista,
		idsPrioridadeHoje: idsPri,
		prioridadePrincipal: principal,
		prioridadeRelogio: prioridadeHoje?.relogio ?? principal?.tempo ?? null,
		abrirModal: Boolean(principal?.id) && exibirModal,
	}
}
